import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import SmartMeterIcon from '../images/smart-meter-icon.svg';
import {reportDWH} from '../energySaleBlockSlice';

const LoadingPage = (props) => {

  let title = props.epiText?.title;
  let subTitle = props.epiText?.subTitle;
  let remark = props.epiText?.remark;

  useExtendedEffect((runSideEffects) => {
    gtag4({
      event: props.isStartWithSelectedPackage ? 'Energy_Step4_CounterCheckPage' : 'Energy_Step3_CounterCheckPage',
      step: props.isStartWithSelectedPackage ? '4' :'3',
      action: 'CounterCheckPage',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'Checking if Have Counter - Display' })
    if (runSideEffects()) {
    }
  },
  [],);


  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <Image className='energy-sale-icon' src={SmartMeterIcon} />
      <h1 className='energy-sale-title' dangerouslySetInnerHTML={{__html: title}}></h1>
      <h2 className='energy-sale-sub-title'>{subTitle}
      <div className="loader-dots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
      </h2>
    </div>
  );

  let currentPageView = (
    <div dangerouslySetInnerHTML={{__html: remark}} className='remark-loading-page'>
    </div>
  );

  return (
    <div className='energy-sale-content-wrapper'>
      {currentPageHeadline}
      <div className='energy-sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
      </div>
    </div>
  );

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    isStartWithSelectedPackage: state.energySaleBlock.isStartWithSelectedPackage,
    epiText: state.energySaleBlock.energySaleBlockData.epiText?.loadingPage
  };
};

const mapDispatchToProps = {
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadingPage);
